<div class="container">
  <div class="text-center mt-3 mb-4">
    <strong class="mainHeading">Redeem Dashboard</strong>
  </div>

<div class="container payroll-dashboard mt-4">
  <!-- Header and Tabs -->
  <div class="header mb-4 d-flex align-items-center justify-content-between">
    <div class="tabs d-flex">
      <button
        *ngFor="let tab of tabs"
        class="btn btn-outline-secondary buttons"
        [class.active]="activeTab === tab"
        (click)="setActiveTab(tab)">
        {{ tab }}
      </button>
    </div>
  </div>



  <div class="tab-content">

<ng-container *ngIf="activeTab === 'Cash And Partner Redeem'">

</ng-container>


    <!-- Total Revenue Tab -->
    <ng-container *ngIf="activeTab === 'Seller Redeem'">
      <div class="container mt-4">
        <!-- Dropdown -->
        <div class="d-flex justify-content-between align-items-center">
          <!-- Dropdown Menu -->
          <div class="form-group mb-3">
            <label for="dashboardSelect" class="form-label trd">Select REVENUE DASHBOARD</label>
            <select class="form-select" id="dashboardSelect" (change)="onDropdownSelection($event)">
              <option value="grid">Grid</option>
              <option value="chart">Charts</option>
            </select>
          </div>

          <!-- Button for "See All" -->
          <!-- <button class="btn btn-link" (click)="onSeeAllClick()">See All</button> -->
          <button class="btn btn-link">See All</button>
        </div>

        <!-- Displaying the view based on the selected option (chart or grid) -->
        <div *ngIf="view === 'chart'">
          <h3>Seller Redeem Amount</h3>
        </div>

        <div *ngIf="view === 'grid'">
          <div class="grid-view">
            <h3>Grid View</h3>
          </div>
        </div>

        <div *ngIf="view === 'chart'" class="mt-4">
          <ngx-charts-bar-vertical
          [view]="[1000, 400]"
          [results]="chartData"
  [scheme]="colorScheme"
  [xAxis]="true"
  [yAxis]="true"
  [showXAxisLabel]="true"
  [showYAxisLabel]="true"

  [legend]="true"
  [animations]="true"

  [xAxisTickFormatting]="rotateXAxisLabels"

  [barPadding]="4"
 > <!-- Rotate labels to avoid truncation -->

          </ngx-charts-bar-vertical>
        </div>

        <div *ngIf="view === 'grid'" class="">
          <div class="table-responsive">
            <table class="table table-bordered text-center align-middle">
              <thead class="table-light">
                <tr>
                  <th scope="col">ID</th>
                  <!-- <t scope="coleller redeem Points -->
                  <th scope="col">Type</th>
                  <th scope="col">Total Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of tableData">
                  <td>{{ row.id }}</td>
                  <!-- <td>{{ row.amount }}</td> -->
                  <td>{{ row.type }}</td>
                  <td>{{ row.totalAmount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="activeTab === 'Seller Redeem Points'">
      <div class="container mt-4">
        <!-- Dropdown -->
        <div class="d-flex justify-content-between align-items-center">
          <!-- Dropdown Menu -->
          <div class="form-group mb-3">
            <label for="dashboardSelect" class="form-label trd">Seller Redeem Points </label>
            <select class="form-select" id="dashboardSelect" (change)="onDropdownSelection($event)">
              <option value="grid">Grid</option>
              <option value="chart">Charts</option>
            </select>
          </div>

          <!-- Button for "See All" -->
          <!-- <button class="btn btn-link" (click)="onSeeAllClick()">See All</button> -->
          <button class="btn btn-link">See All</button>
        </div>

        <!-- Displaying the view based on the selected option (chart or grid) -->
        <div *ngIf="view === 'chart'">
          <h3>Seller Redeem Points</h3>
        </div>

        <div *ngIf="view === 'grid'">
          <div class="grid-view">
            <h3>Grid View</h3>
          </div>
        </div>

        <div *ngIf="view === 'chart'" class="mt-4">
          <ngx-charts-bar-vertical
          [view]="[1000, 400]"
          [results]="chartData2"
  [scheme]="colorScheme2"
  [xAxis]="true"
  [yAxis]="true"
  [showXAxisLabel]="true"
  [showYAxisLabel]="true"
  [xAxisLabel]="'Request Types'"
  [yAxisLabel]="'Amount (SAR)'"
  [legend]="true"
  [animations]="true"

  [xAxisTickFormatting]="rotateXAxisLabel2"

  [barPadding]="4"
 > <!-- Rotate labels to avoid truncation -->

          </ngx-charts-bar-vertical>
        </div>

        <div *ngIf="view === 'grid'" class="">
          <div class="table-responsive">
            <table class="table table-bordered text-center align-middle">
              <thead class="table-light">
                <tr>
                  <th scope="col">ID</th>
                  <!-- <th scope="col">Amount</th> -->
                  <th scope="col">Type</th>
                  <th scope="col">Total Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of tableData2">
                  <td>{{ row.id }}</td>
                  <!-- <td>{{ row.amount }}</td> -->
                  <td>{{ row.type }}</td>
                  <td>{{ row.totalAmount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ng-container>








  </div>

</div>